/* SchemaForm helper for item (steps) rendering */
import React from "react";
import lodash from "lodash";
import BaseField from "components/util/schema_form/fields/BaseField";
import { HelpComponent } from "components/util/schema_form/util/help_util";
import FieldRender from "./SchemaForm.sub.FieldRender.view";


const ItemRender = (props) => {

  // Props extraction for easier access
  const input = props.input;
  const nextInput = props.nextInput;
  const parentKey = props.parentKey;
  const values = props.values
  const setValues = props.setValues
  const sectionIdx = props.sectionIdx

  // Input properties
  const multiple = input.multiple ?? false;
  const minFields = input.min_fields ?? 1;
  const maxFields = input.max_fields ?? 100;
  const name = input.name;
  const type = input.type;
  const label = input.label;
  const hidden = input?.hidden ?? false;
  const disabled = input?.disabled ?? props.isReadOnly;
  let required = input?.required ?? true;
  if (hidden == true) required = false;
  const caption = input?.caption ?? ""
  const helpMessage = input?.help_message ?? "";

  // Key and value determination
  const key = parentKey == "" ? name : `${parentKey}.${name}`
  const keyValue = lodash.get(values, key)
  const parentValue = lodash.get(values, parentKey)


  return <li className="step-item"
    style={{
      // Adjust margin bottom based on the presence of the next input and side steps
      marginBottom: (nextInput == null || nextInput?.label) && props.showSideSteps ? "1.2rem" : "0rem"
    }}>

    <div className="step-content-wrapper">
      <span className="step-icon step-icon-pseudo step-icon-soft-dark ml-2"></span>
      <div className="step-content pt-0"
        style={{
          // Adjust padding based on the presence of the next input and label
          paddingBottom: nextInput == null || nextInput?.label ? "0.7rem" : "0.4rem",
          marginLeft: "0.85rem",
          maxWidth: "calc(100% - 3rem)"
        }}>

        {/* Multiple item render */}
        {multiple &&
          (() => {
            // Prefill default array with n minFields NULL values
            const defaultArray = new Array(minFields).fill(null);
            return (
              <div>
                {/* Render label and help message when there are no items */}
                {(keyValue ?? defaultArray).length == 0 &&
                  (type == "SECTION" ?
                    <div className="w-100 mt-1">
                      <a class="d-flex mb-1 w-100 justify-content-between"
                        data-toggle="collapse"
                        href={"#"}
                        style={{ cursor: "default" }}>
                        {label != "" ?
                          <span class="dropdown-header p-0">
                            <span style={{ color: "#777" }}>{label}</span>
                            {helpMessage != null ? <HelpComponent helpMessage={helpMessage} /> : null}
                          </span> : null}
                      </a>
                      <hr class="mt-2 w-100" style={{ border: "none", height: "1.5px", background: "#e7eaf3" }} />
                    </div>
                    :
                    <BaseField
                      name={name}
                      label={label}
                      required={required}
                      caption={caption}
                      helpMessage={helpMessage}
                    > <div></div>
                    </BaseField>)
                }

                {/* Render each item in the multiple field */}
                {(keyValue ?? defaultArray).map((value, idx) => {
                  let itemLen = (keyValue ?? defaultArray).length;
                  let newInput = {
                    ...input,
                    name: `${name}[${idx}]`,
                    label: idx == 0 || type == "SECTION" ? label : ""
                  }
                  return <div
                    key={idx}
                    class="d-flex align-items-start justify-content-between mb-1 mt-n1">
                    <div className={"d-flex"}
                      style={{ width: itemLen > 1 ? "92%" : "100%" }}>

                      {/* Show index badge if more than one item */}
                      {itemLen > 1 &&
                        <span className="mr-1 mt-1"
                          style={{
                            fontSize: "0.72em", color: "#80858a", background: "#f0f0f0",
                            height: "1rem", padding: "0rem 0.3rem", borderRadius: "50%"
                          }}>{idx + 1}</span>
                      }

                      {/* Render the field for the current item */}
                      <div className="w-100">
                        <FieldRender {...props}
                          sectionIdx={idx}
                          input={newInput}
                        />
                      </div>
                    </div>

                    {/* Render remove item button if index is greater or equal to minFields */}
                    {!disabled && idx >= minFields &&
                      <div class="text-right"
                        style={{ width: "8%" }}>

                        <button type="button"
                          class="btn btn-link px-1"
                          onClick={() => {
                            let tempVal = {}
                            let tempVals = keyValue ?? defaultArray
                            tempVals.splice(idx, 1)
                            tempVal[name] = tempVals
                            setValues({ ...values, ...tempVal });
                          }}
                          style={{ color: "#c0c5d5", fontSize: "1.15em" }}>
                          <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>}
                  </div>
                })}

                {/* Render add item button if index is less than maxFields */}
                {!disabled && (keyValue ?? defaultArray).length < maxFields &&
                  <button type="button" class="btn btn-link pl-0 mt-1 pt-1 pb-1"
                    onClick={() => {
                      let tempVal = {}
                      tempVal[name] = [...(keyValue ?? defaultArray), ...[null]]
                      if (parentKey == "") setValues({ ...values, ...tempVal });
                      else setValues(lodash.set(values, `${parentKey}`, { ...parentValue, ...tempVal }))
                    }}
                    style={{ color: "#777", fontWeight: "normal", fontSize: "0.96em" }}>
                    <div className="d-flex align-items-center">
                      <i class="fas fa-plus"></i>&nbsp;Agregar
                      {/* For sections append section name */}
                      {label && label != "" && type == "SECTION" &&
                        <span className="ml-1 d-inline-block text-truncate" style={{ maxWidth: "10rem" }}>&quot;{label}&quot;</span>
                      }
                    </div>
                  </button>}
              </div>
            )
          })()
        }


        {/* For single fields, just call FieldRender */}
        {!multiple &&
          <FieldRender
            {...props}
            sectionIdx={sectionIdx} />}

      </div>
    </div>
  </li>
}

export default ItemRender;